<template>
    <div>

        <div>
            <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">物品综合查询</div>
            <el-row style="margin-top: 9px;">
                <div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px;">

                    <el-row style="padding-left: 46px; padding-top: 40px;">

                        <el-col :span="4">
                            <span>物品名称</span>
                            <el-input v-model="input" placeholder="请输入物品名称" style="width: 65%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="4">
                            <span>物品编号</span>
                            <el-input v-model="input" placeholder="请输入物品编号" style="width: 65%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="4">
                            <span>规格型号</span>
                            <el-select v-model="value" placeholder="请选择" style="width: 65%; margin-left: 10px;"
                                filterable>
                                <el-option v-for="item in options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>

                        <el-col :span="4">
                            <span>颜色</span>
                            <el-select v-model="value" placeholder="请选择" style="width: 65%; margin-left: 10px;"
                                filterable>
                                <el-option v-for="item in options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>

                        <el-col :span="4">
                            <span>借用人</span>
                            <el-select v-model="value" placeholder="全部" style="width: 65%; margin-left: 10px;"
                                filterable>
                                <el-option v-for="item in options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>

                        <el-col :span="4">
                            <span>归还状态</span>
                            <el-select v-model="value" placeholder="全部" style="width: 65%; margin-left: 10px;"
                                filterable>
                                <el-option v-for="item in options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>



                    </el-row>

                    <el-row style="margin-top: 15px; padding-left: 46px;">

                        <el-col :span="4">
                            <span>归还时间</span>
                            <el-select v-model="value" placeholder="全部" style="width: 65%; margin-left: 10px;"
                                filterable>
                                <el-option v-for="item in options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>

                        <el-col :span="4">
                            <span>是否有损坏</span>
                            <el-select v-model="value" placeholder="全部" style="width: 50%; margin-left: 10px;"
                                filterable>
                                <el-option v-for="item in options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>

                        <el-col :span="4">
                            <el-input v-model="input" placeholder="请输入查询内容" style="width: 90%;">
                            </el-input>
                        </el-col>

                        <el-col :span="5">
                            <div>
                                <el-button
                                    style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                    查询</el-button>
                                <el-button
                                    style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                    导出</el-button>
                            </div>
                        </el-col>

                    </el-row>

                    <el-row style="margin: 0px 2%; margin-top: 10px;">
                        <el-row>
                            <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                                :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" height="595"
                                tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55">
                                </el-table-column>
                                <el-table-column align="center" label="序号">
                                    <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                                </el-table-column>
                                <el-table-column prop="fgs" align="center" label="物品名称"></el-table-column>
                                <el-table-column prop="csgs" align="center" label="物品编号"></el-table-column>
                                <el-table-column prop="bankuai" align="center" label="规格型号"></el-table-column>
                                <el-table-column prop="xiangmu" align="center" label="颜色"></el-table-column>
                                <el-table-column prop="xiangmu" align="center" label="重量"></el-table-column>
                                <el-table-column prop="xiangmu" align="center" label="品牌"></el-table-column>
                                <el-table-column prop="gangwei" align="center" label="借出时间"></el-table-column>
                                <el-table-column prop="gangwei" align="center" label="借用人"></el-table-column>
                                <el-table-column prop="gangwei" align="center" label="电话号码"></el-table-column>
                                <el-table-column prop="state" align="center" label="归还状态">
                                    <template slot-scope="scope">
                                        <img src="../../../assets/stateImg/状态_已归还.png" v-show="scope.row.state === '0'" />
                                        <img src="../../../assets/stateImg/状态_未归还.png" v-show="scope.row.state === '1'" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="gangwei" align="center" label="归还时间"></el-table-column>
                                <el-table-column prop="gangwei" align="center" label="是否有损坏"></el-table-column>
                                <el-table-column prop="gangwei" align="center" label="备注"></el-table-column>
                            </el-table>
                        </el-row>
                        <el-row style="margin-top: 10px; text-align: center;">
                            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                                layout=" prev, pager, next, jumper" :total="total">
                            </el-pagination>
                        </el-row>
                    </el-row>
                </div>
            </el-row>
        </div>

    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data() {
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [{
                    fgs: "123",
                    csgs: "123",
                    bankuai: "123",
                    xiangmu: "123",
                    gangwei: "123",
                    state: "0"
                }, {
                    fgs: "123",
                    csgs: "123",
                    bankuai: "123",
                    xiangmu: "123",
                    gangwei: "123",
                    state: "1"
                }],

                //页面相关

            };
        },
        methods: {

        },
        created() {

        }
    }
</script>

<style scoped="scoped">
    >>>.el-button:hover {
        background-color: #FFFFFF;
    }

    >>>.el-button:focus {
        background-color: #FFFFFF;
    }

    >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #006E4B;
    }

    >>>.el-input__inner:focus {
        border-color: #006E4B;
    }

    >>>.el-select .el-input.is-focus .el-input__inner {
        border-color: #006E4B;
    }

    >>>.el-checkbox__input.is-checked .el-checkbox__inner,
    >>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-checkbox__inner:hover {
        border-color: #006E4B;
    }
</style>



// WEBPACK FOOTER //
// WpzhCx.vue?79cb4b02